import type { TEventSchema } from '../types/taxonomy.types';

export const pickDeclaredProperties = (properties: Record<string, unknown> = {}, schema: TEventSchema) =>
  Object.entries(properties).reduce<{ properties: Record<string, unknown>; droppedKeys: Array<string> }>(
    (declared, [key, value]) => {
      if (value === undefined) return declared;

      const result = Object.prototype.hasOwnProperty.call(schema.shape, key) ? schema.shape[key].safeParse(value) : undefined;

      if (result?.success && Object.is(result.data, value)) declared.properties[key] = value;
      else declared.droppedKeys.push(key);

      return declared;
    },
    { properties: {}, droppedKeys: [] },
  );
